import * as React from "react";

const IconFilterArrowDown: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <circle cx="7.5" cy="7.5" r="7.5" fill="#EEE" />
                <path
                    fill="#666"
                    fillRule="nonzero"
                    d="M7.738 9.896l2.163-2.29c.212-.224.062-.606-.237-.606H5.336c-.299 0-.449.382-.237.607l2.163 2.289a.324.324 0 00.476 0z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFilterArrowDown);
